//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.AECDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.AECDesign.AlternateCoverThicknessBuilder.js";
import "../no/Expression.js";
import "../Features/Features.AECDesign.RebarHookBlockBuilder.js";
import "../Features/Features.AECDesign.RebarLimitBuilder.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../Features/Features.AECDesign.MaterialSectionBuilder.js";
import "../no/ScCollector.js";
import "../no/Features.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
let d=[[[1,"AlternateCoverThickness",0,"Features.AECDesign.AlternateCoverThicknessBuilder",0],[1,"BendingRadius",0,"Expression",0],[1,"Diameter",0,"Expression",0],[1,"EndHook",0,"Features.AECDesign.RebarHookBlockBuilder",0],[1,"EndLimit",0,"Features.AECDesign.RebarLimitBuilder",0],[1,"EndPointLocation",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"ExcludeSegment",1,0],[1,"IntervalDistance",0,"Expression",0],[1,"MaterialSection",0,"Features.AECDesign.MaterialSectionBuilder",0],[0,"NumberOfRebars",1,0],[0,"NumberOfTurns",1,0],[1,"PitchDistance",0,"Expression",0],[0,"PlacementMethod",1,0],[0,"ReverseDirection",1,0],[0,"SelectEdge",0,"ScCollector",0],[0,"SpacingSetting",1,0],[1,"StartFace",0,"ScCollector",0],[1,"StartHook",0,"Features.AECDesign.RebarHookBlockBuilder",0],[1,"StartLimit",0,"Features.AECDesign.RebarLimitBuilder",0],[0,"StartPoint",1,"Point",0],[1,"ThicknessDistance",0,"Expression",0],[0,"TurnsAtEnd",1,0],[0,"TurnsAtStart",1,0]],[[[],"UpdateReferencedRebarBodies",{},0,0]],[]];
SPLM.Features.AECDesign.CrossingRebarsBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AECDesign.CrossingRebarsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;